<template>
    <div class="backoffice-expenses">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.title || "Expenses List" }}</h2>
            </div>
            <div class="right">
                <v-btn color="primary" dark @click="expensesModal = true">
                    <v-icon small>mdi-plus</v-icon>
                 <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.newExpense || "New expense" }}</span>
                </v-btn>
            </div>
        </div>
        <v-dialog v-model="expensesModal" max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.newExpense || "New expense" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="expensesModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <p class="custom-label">{{$page.props.lang.table_date|| 'Date'}}</p>
                                <v-menu
                                    v-model="startDatePicker"
                                    :close-on-content-click="false"
                                    :return-value.sync="today" 
                                    transition="scale-transition"
                                    offset-y 
                                    min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            :value="newExpense.date | formatDate" :hide-details="!responseErrors.date"
                                            append-icon="mdi-menu-down" readonly v-bind="attrs" v-on="on" @click:append="startDatePicker = true"  
                                            :error-messages="responseErrors.date" @focus="responseErrors.date=''"
                                            outlined dense solo flat>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker 
                                        v-model="newExpense.date" 
                                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn color="regular" @click="startDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                            <v-btn color="primary" @click="startDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                             </v-col>
                             <v-col cols="12">
                                 <p class="custom-label">{{ $page.props.lang.table_trainer || 'Trainer' }}</p>
                                <v-select 
                                v-model="newExpense.trainer_id" item-value='id' item-text='full_name' 
                                :items="trainers" 
                                dense outlined :hide-details="!responseErrors.trainer_id" 
                                :error-messages="responseErrors.trainer_id" @focus="responseErrors.trainer_id=''">
                                </v-select>
                            </v-col>
                            <v-col cols="12"> 
                                <p class="custom-label">{{ $page.props.lang.table_category || 'Category' }}</p>
                                <v-select v-model="newExpense.category_id" 
                                            :items="categoriesData"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="responseErrors.category_id" @change="responseErrors.category_id=''" 
                                            class="period-select" outlined dense :hide-details="!responseErrors.category_id"></v-select>
                            <a href="javascript:void(0)"  @click="addCategoryModal = true" class="mt-1"> {{ $page.props.lang.addCategory || "Create New Category" }} </a>
                            </v-col>
                            <v-col cols="12"> 
                                <p class="custom-label">{{ $page.props.lang.table_amount || 'Amount' }}</p>
                                <v-text-field v-model="newExpense.amount" 
                                    :suffix="$page.props.organization.settings.currency" 
                                    :error-messages="responseErrors.amount" 
                                    :hide-details="!responseErrors.amount"
                                    @focus="responseErrors.amount=''"
                                    outlined dense ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <p class="custom-label">{{ $page.props.lang.table_supplier || 'Supplier' }}</p>
                                <v-text-field v-model="newExpense.supplier" 
                                 :error-messages="responseErrors.supplier" :hide-details="!responseErrors.supplier"
                                 @focus="responseErrors.supplier=''" outlined dense></v-text-field>
                            </v-col>
                             <v-col cols="12">
                                <p class="custom-label">{{$page.props.lang.table_description || 'Description' }}</p>
                                <v-textarea v-model="newExpense.description" 
                                    :error-messages="responseErrors.description" @focus="responseErrors.description=''" 
                                    rows="3" outlined dense :hide-details="!responseErrors.description"></v-textarea>
                            </v-col> 
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="expensesModal = false" color="regular">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn @click="add" :loading="savingExpense" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editExpModal" max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editExpense || "Edit expense" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="editExpModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <p class="custom-label">{{$page.props.lang.table_date|| 'Date'}}</p>
                                <v-menu
                                    v-model="editStartDatePicker"
                                    :close-on-content-click="false"
                                    :return-value.sync="today" 
                                    transition="scale-transition"
                                    offset-y 
                                    min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            :value="currentExpense.date | formatDate" :hide-details="!responseErrors.date"
                                            append-icon="mdi-menu-down" readonly v-bind="attrs" v-on="on" @click:append="editStartDatePicker = true"  
                                            :error-messages="responseErrors.date" @focus="responseErrors.date=''"
                                            outlined dense solo flat>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker 
                                        v-model="currentExpense.date" 
                                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn color="regular" @click="editStartDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                            <v-btn color="primary" @click="editStartDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                             </v-col>
                             <v-col cols="12">
                                 <p class="custom-label">{{ $page.props.lang.table_trainer || 'Trainer' }}</p>
                                <v-select 
                                v-model="currentExpense.trainer_id" item-value='id' item-text='full_name' 
                                :items="trainers" 
                                dense outlined :hide-details="!responseErrors.trainer_id" 
                                :error-messages="responseErrors.trainer_id" @focus="responseErrors.trainer_id=''">
                                </v-select>
                            </v-col>
                            <v-col cols="12"> 
                                <p class="custom-label">{{ $page.props.lang.table_category || 'Category' }}</p>
                                <v-select v-model="currentExpense.category_id" 
                                            :items="categories"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="responseErrors.category_id" @change="responseErrors.category_id=''" 
                                            class="period-select" outlined dense :hide-details="!responseErrors.category_id"></v-select>
                            </v-col> 
                            <v-col cols="12"> 
                                <p class="custom-label">{{ $page.props.lang.table_amount || 'Amount' }}</p>
                                <v-text-field v-model="currentExpense.amount" 
                                    :suffix="$page.props.organization.settings.currency" 
                                    :error-messages="responseErrors.amount" 
                                    :hide-details="!responseErrors.amount"
                                    @focus="responseErrors.amount=''"
                                    outlined dense ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <p class="custom-label">{{ $page.props.lang.table_supplier || 'Supplier' }}</p>
                                <v-text-field v-model="currentExpense.supplier" 
                                 :error-messages="responseErrors.supplier" :hide-details="!responseErrors.supplier"
                                 @focus="responseErrors.supplier=''" outlined dense></v-text-field>
                            </v-col>
                             <v-col cols="12">
                                <p class="custom-label">{{$page.props.lang.table_description || 'Description' }}</p>
                                <v-textarea v-model="currentExpense.description" 
                                    :error-messages="responseErrors.description" @focus="responseErrors.description=''" 
                                    rows="3" outlined dense :hide-details="!responseErrors.description"></v-textarea>
                            </v-col> 
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="editExpModal = false" color="regular">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn @click="update" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addCategoryModal" max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.newCategory || "New category" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="addCategoryModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                            <v-row>
                                <v-col cols="8">    
                                    <p class="custom-label">{{ $page.props.lang.category_name || 'Category name' }}</p>
                                    <v-text-field v-model="newCategory.name" 
                                    :error-messages="responseErrors.name" :hide-details="!responseErrors.name"
                                    @focus="responseErrors.name=''" outlined dense></v-text-field>
                                </v-col> 
                                <v-col cols="4">
                                    <v-btn @click="saveCategory" :loading="savingCategory" color="primary" class="mt-6 ml-8">{{ $page.props.lang.save || "Save" }}</v-btn>
                                </v-col>    
                            </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <div class="table-container">
            <v-data-table
            :headers="expensesHeaders"
            :items="expenses.data"
            :server-items-length="expenses.total"
            :sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"
            item-key="item.id"
            :page="expenses.current_page"
            :options.sync="options"
            :items-per-page="options.itemsPerPage"
            mobile-breakpoint="0"
            :footer-props="{
                    'items-per-page-options': [5, 10, 15]
                }"
            >
            <template v-slot:item.date="{ item }">
                       {{ item.date | formatDate }} 
            </template>
            <template v-slot:item.trainer_id="{ item }">
                       {{ item.trainer}} 
            </template>
            <template v-slot:item.category_id="{ item }">
                       {{ item.category}} 
            </template>
            <template v-slot:item.amount="{ item }">
                       {{ item.amount}} 
            </template>
            <template v-slot:item.supplier="{ item }">
                <span v-if="item.supplier !== null">
                    {{ item.supplier }}
                </span>
                <span v-else>{{$page.props.lang.no_supplier || "No supplier added"}}</span>
            </template>
            <template v-slot:item.description="{ item }">
                <span v-if="item.description !== null">
                    {{ item.description }}
                </span>
                <span v-else>{{$page.props.lang.no_description || "No description"}}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <v-btn @click="openEditModal(item)" :id="'edit' + item.id" icon>
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip :activator="'#edit'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.edit || "Edit"}}</span>
                        </v-tooltip>
                </v-btn>
                <v-btn @click="openDeleteModal(item)" :id="'delete' + item.id" class="delete-icon" icon>
                        <v-icon>mdi-trash-can-outline</v-icon>
                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.delete || "Delete"}}</span>
                        </v-tooltip>
                </v-btn>
            </template>
            </v-data-table>
            <ConfirmModal 
                :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
                :description="$page.props.lang.delete_confirmation_description || 'If you click YES, the expense will be permanently deleted. Are you sure?'" 
                :open="deleteModal" 
                @no="deleteModal = false" 
                @yes="deleteExpense" 
                @close="deleteModal = false">
            </ConfirmModal>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import ConfirmModal from '@/js/Components/ConfirmModal'
import Pagination from '@/js/Components/Pagination'
import EventBus from '@/js/eventbus'
import pickBy from 'lodash/pickBy'


export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "List of Expenses"
        }
    },
    layout: AppLayout,
    components:{ ConfirmModal, Pagination },
    props:{
        expenses: Object,
        trainers: Array,
        categories: Array,
        filters: Object
    },

    data(){
        return{
        categoriesData: this.categories,
        expensesModal: false,
        editExpModal: false,
        addCategoryModal: false,
        savingExpense: false,
        savingCategory: false,
        today : moment().format('YYYY-MM-DD'),
        expensesHeaders: [
                {text: this.$page.props.lang.table_date || 'Date', value: 'date', align: 'start'},
                {text: this.$page.props.lang.table_trainer || 'Trainer', value: 'trainer_id', sortable: false, align:'start'},
                {text: this.$page.props.lang.table_category || 'Category', value: 'category_id', sortable: false, align: 'left'},
                {text: this.$page.props.lang.table_amount || 'Amount', value: 'amount', sortable: false, align: 'left'},
                {text: this.$page.props.lang.table_supplier || 'Supplier', value: 'supplier', sortable: false, align: 'left'},
                {text: this.$page.props.lang.table_description || 'Description', value: 'description', sortable: false, align: 'left'},
                {text: '', value: 'action', sortable: false, align: 'end'}
            ],
        newExpense: {
                date: moment().format('YYYY-MM-DD'),
                trainer_id: null,
                category_id: null,
                amount: null,
                supplier: '',
                description: ''
            },
        resetExpense: {
                date: moment().format('YYYY-MM-DD'),
                trainer_id: null,
                category_id: null,
                amount: null,
                supplier: '',
                description: ''
            },
        newCategory: {
            name: '',
            type: 'expense'
        },
        form: {
        search: this.filters.search,
        },  
        startDatePicker: false,
        editStartDatePicker: false,
        responseErrors: {},
        messageObjects: [],
        options:{page:this.expenses.current_page},
        page: null,
        sortBy: [],
        sortDesc: [],
        expForDeleteId: null,
        deleteModal: false,
        currentExpense: {},
        addedCategory: {}
        }
    },
    watch:{
        expensesModal: function (value) {
            if (value===false) {
                this.newExpense = Object.assign({}, this.resetExpense);
            }
        },
        options:{
             
             handler (val, oldVal) {
                
                if(val.page != oldVal.page || val.sortBy != oldVal.sortBy || val.sortDesc != oldVal.sortDesc || val.itemsPerPage != oldVal.itemsPerPage){

                    let data = {}
                    let order = this.options.sortDesc[0]===false ? 'asc' : 'desc';

                    if (this.options.sortDesc.length>0 & oldVal.sortDesc != val.sortDesc) { 
                        data.order = order
                        data.sort = this.options.sortBy[0]
                        data.page = oldVal.page
                        
                    }else{
                        data.page = val.page;
                    }
                  
                    data.items_per_page = this.options.itemsPerPage;
                   
                    this.$inertia.get('/backoffice/expenses', pickBy(data), {preserveState: true});
                    this.options.page = this.expenses.current_page; 
                }
              
            },
            deep: true,
        },
    },
    computed:{
        getTrainer(){
            
            return this.trainers.find(element => {
                return element.id == this.trainers.id
            }).full_name;
            
        }
    },
    methods:{
        
        add(){
            this.savingExpense = true;
            axios.post('/backoffice/expenses/store', this.newExpense)
                .then(response => {
                    this.savingExpense = false;
                    if (response.data.status==="OK") {
                        this.expensesModal = false
                        this.$inertia.reload()
                         EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {             
                    this.savingExpense = false;      
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        update(){
            axios.post('/backoffice/expenses/update', this.currentExpense)
                .then(response => {
                    if (response.data.status==="OK") {
                        this.editExpModal = false
                        this.$inertia.reload()
                        EventBus.$emit('SHOW_NOTIFICATION',{  
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {                   
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        deleteExpense(){
            axios.post('/backoffice/expenses/delete', {id: this.expForDeleteId})
                .then(response => {
                    if (response.data.status==="OK") {
                        this.$inertia.reload()
                       EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {                   
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
                this.deleteModal = false
        },

        openDeleteModal(item){
            this.deleteModal = true
            this.expForDeleteId = item.id
        },

        openEditModal(item){
            this.responseErrors = {};
             axios.get('/backoffice/expenses/getExpense/'+ item.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.editExpModal = true
                        this.currentExpense = response.data.expense
                    }else{
                        alert(response.data.message)
                    }
                });
        },

        saveCategory(){
            this.savingCategory = true;
            axios.post('/backoffice/expenses/saveCategory', this.newCategory)
                .then(response => {
                    this.savingCategory = false;
                    if (response.data.status==="OK") {
                        this.addCategoryModal = false
                        this.categoriesData.push({id: response.data.category.id, name: response.data.category.name});
                        this.newExpense.category_id = response.data.category.id;
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: response.data.message,
                            color: 'success',
                            timeout: 2000
                        }) 
                    }
                })
                .catch(error => {     
                    this.savingCategory = false;              
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        }
    }

}
</script>
